export function getBrowserNotificationApi(): typeof Notification | null {
  if (typeof window === 'undefined') return null;

  const notificationApi = window.Notification;

  return notificationApi ?? null;
}

export function getBrowserNotificationPermission(): NotificationPermission | null {
  return getBrowserNotificationApi()?.permission ?? null;
}

export function requestBrowserNotificationPermission() {
  return getBrowserNotificationApi()?.requestPermission();
}

export function showBrowserNotification(title: string, options?: NotificationOptions) {
  const notificationApi = getBrowserNotificationApi();

  if (!notificationApi || notificationApi.permission !== 'granted') return;

  new notificationApi(title, options);
}
